import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'

export default () => {
  const { designSystemReleaseInterFont: isFontMigrationEnabled } = useFlags()
  const latoFont = 'Lato, Helvetica, Arial, sans-serif'

  return !isFontMigrationEnabled
    ? (
      <style>
        {`
        :root {
          --art-font-family-body: ${latoFont};
          --art-font-family-heading: ${latoFont};
        }
      `}
      </style>
    )
    : <></>
}
